import "core-js/modules/es.array.map.js";
import React from 'react';
import { CheckCircle } from '@finect/tabular-icons/checkCircle';
import { MetadataBlock, FactsBlockInner } from './partials';
export var FactsBlock = function FactsBlock(_ref) {
  var facts = _ref.facts;
  return React.createElement(MetadataBlock, null, React.createElement(FactsBlockInner, null, React.createElement("ul", null, facts.map(function (item, key) {
    return React.createElement("li", {
      key: key
    }, React.createElement(CheckCircle, null), React.createElement("span", null, item));
  }))));
};